
import {editdevicesub, getsubdevice, sendcommand, sendcommandnewsub} from '../../api/device'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: 'NewSubDeviceChild',
directives: {TransferDom},
data () {
return {
deviceObj: '',
subDeviceImgArr: [],
childArr: [],

studyShow: false,
editShow: false,
editObj: {
id: '',
dtype: '',
name: '',
notify: false
}
}
},
created () {
this.getStartData()
},
methods: {
getStartData () {
this.deviceObj = this.$store.getters.get_child_obj
this.subDeviceImgArr = this.common.getSubDeviceImg()
this.getChildList()
},

openChildDevice (item) {
if (item.dtype === 2 || item.dtype === 11 || item.dtype === 12 || item.dtype === 13 || item.dtype === 14 || item.dtype === 51 || item.dtype === 52) {
this.$store.commit('set_sub_device', item)
this.$router.push('/secondView')
}
},
openEditChild (item) {
console.log(item)
this.editShow = true
this.editObj.name = item.setname === '' ? item.name : item.setname
this.editObj.dtype = item.dtype
this.editObj.notify = item.dtype === 6 ? item.notify === 1 : false
this.editObj.id = item.id
},

addStudy () {
this.studyShow = true
let data = {
did: parseInt(this.deviceObj.id),
cmd: 'addsub'
}
sendcommand(data).then(res => {
this.studyShow = false
this.$toast('成功发送指令')
}).catch(() => {})
},
sendZigbee (item, val) {

if (item.status === 0) {
return
}
let value = {status: val}

let data = {
did: item.pid,
subid: item.device_id,
iszigbee: item.config.iszigbee,
value: JSON.stringify(value)
}
sendcommandnewsub(data).then(res => {
this.$toast('成功')
this.getChildList()
}).catch(() => {
this.$toast('失败')
})
},
editCommit () {
let data = {
did: parseInt(this.editObj.id),
name: this.editObj.name,
pid: parseInt(this.deviceObj.id)
}
if (this.editObj.dtype === 6) {
data.notify = this.editObj.notify ? 1 : 0
}
editdevicesub(data).then(res => {
this.editShow = false
if (res.code === 200) {
this.$toast('编辑成功')
this.getChildList()
} else {
this.$toast(res.msg)
}
}).catch(() => {
this.editShow = false
this.$toast('编辑失败')
})
},


getChildList () {
let data = {
did: parseInt(this.deviceObj.id)
}
getsubdevice(data).then(res => {
let arr = res.data && res.data.length > 0 ? res.data : ''
let list = []
for (let i = 0; i < arr.length; i++) {
let obj = arr[i]
obj.isShow = false
obj.status = this.getSubDeviceStatus(arr[i])
if (arr[i].config !== '') {
obj.config = JSON.parse(arr[i].config)
while (typeof obj.config === 'string') {
obj.config = JSON.parse(obj.config)
}
}
list.push(obj)
}
this.childArr = list
}).catch(() => {
this.$toast.fail('失败')
})
},

getSubDeviceStatus (item) {




if ([2, 12, 13, 52, 11, 14].indexOf(item.dtype) > -1) {

const stime = new Date(item.hearttime.replace(/-/g, '/')).getTime()
const etime = new Date().getTime()
const usedTime = etime - stime
const hours = Math.floor(usedTime / (3600 * 1000))
if (hours < 48) {
return 1
} else {
return 0
}
} else {
return 2
}
},
getModelNameShow (model) {
let result = false
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
result = true
} else if (arr[arr.length - 1] === 'A') {
result = true
}
}
} else {
result = true
}
return result
},
getModelNameClass (model, status) {
let result = 'model-left-z'
if (status === 0) {
result = 'model-left-level'
} else {
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
result = 'model-left-f'
} else if (arr[arr.length - 1] === 'A') {
result = 'model-left-a'
}
}
}
}
return result
},
getModelName (model) {
let result = model
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {

result = '智慧型'
} else if (arr[arr.length - 1] === 'A') {

result = '普通型'
}
}
}
return result
},
getChildImgUrl (dType) {
let img = this.subDeviceImgArr[this.subDeviceImgArr.length - 1].imgUrl
let childDeviceImg = this.subDeviceImgArr.find(r => r.dtype === parseInt(dType))
if (childDeviceImg) {
img = childDeviceImg.imgUrl
}
return img
},
getShowDetail (dType) {
return [2, 11, 12, 13, 14, 51, 52].indexOf(dType) >= 0
},

getMPaName (pressure) {
return pressure / 1000000
},

getLevelName (level) {
return level / 100
},

getChildSwitch (val) {
if (val === '1') {
return '开启'
} else {
return '关闭'
}
},
getShowOnlineTime (model) {
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
return true
} else if (arr[arr.length - 1] === 'A') {
return false
}
}
} else {
return false
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/NewSubDeviceChild.vue